/**
 * The app's API surface: one statically composed object, typechecked against
 * ApiContract. Supabase owns the contract by default; the relay owns model
 * streaming and demo-bot provisioning, and wins those keys by spread order.
 *
 * `satisfies` is the conformance check — a missing or drifted method is a
 * compile error, so there is no runtime routing and no separate audit script.
 */

import { SupabaseAdapter } from './adapters/supabase'
import { RelayAdapter } from './adapters/relay'
import type { ApiContract } from './contract'

const api = {
  ...SupabaseAdapter,
  ...RelayAdapter,
} satisfies ApiContract

export default api
